import { Pricing } from '@api/Celebrities';
import { formatPrice } from '@common/utils';
import { useYela } from '@hooks/useYela';
import useTranslation from 'next-translate/useTranslation';
import { I18N_PROFILE_CONTEXT, PER_MESSAGE } from '../ProfileForm.constants';
import { PriceTextStyle, PriceTextText, PriceTextValue } from './PriceText.styles';

export const PriceText = ({ price, currencyCode, currencySymbol }: Pricing): JSX.Element => {
  const { t } = useTranslation(I18N_PROFILE_CONTEXT);
  const { language } = useYela();

  return (
    <PriceTextStyle>
      <PriceTextValue>
        {price &&
          currencySymbol &&
          formatPrice({ currencyCode, currencySymbol, value: price, arabicCharacterSpecificFlip: language == 'ar' })}
      </PriceTextValue>
      <PriceTextText>{t(PER_MESSAGE)}</PriceTextText>
    </PriceTextStyle>
  );
};
